var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkModeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 57,
    viewBox: "0 0 70 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4532_4552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.641602 43.9238H2.59278L4.87691 49.7922C5.15952 50.4871 5.3647 51.4395 5.3647 51.4395C5.3647 51.4395 5.56989 50.4871 5.90412 49.7922L8.67604 43.7686H8.90703L11.7306 49.7663C12.0648 50.4871 12.2958 51.4395 12.2958 51.4395C12.2958 51.4395 12.501 50.4612 12.7836 49.7663L15.0677 43.9238H16.8898L12.4752 54.8117H12.2184L9.29159 48.4024C8.98317 47.7593 8.77798 46.8328 8.77798 46.8328C8.77798 46.8328 8.54699 47.7852 8.26438 48.4024L5.26147 54.8117H5.00466L0.641602 43.9238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0977 39.5747C19.0977 38.828 19.7132 38.2871 20.3817 38.2871C21.0501 38.2871 21.6657 38.828 21.6657 39.5747C21.6657 40.3213 21.0501 40.8363 20.3817 40.8363C19.7132 40.8363 19.0977 40.3213 19.0977 39.5747ZM19.4835 43.9238H21.2798V54.58H19.4835V43.9238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1309 43.924H26.9272L26.8756 46.0087C27.5427 44.3873 28.7235 43.7183 29.9817 43.7183C30.7779 43.7183 31.3419 43.8981 31.8297 44.2333L31.1367 45.8029C30.8025 45.5713 30.3405 45.3914 29.6733 45.3914C28.1583 45.3914 26.9272 46.4719 26.9272 48.9694V54.5802H25.1309V43.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1209 53.2679C40.7121 53.2679 41.7909 52.6248 42.4839 51.8523L43.5872 52.9328C42.6116 54.0391 41.1999 54.7858 39.1209 54.7858C35.6302 54.7858 33.3706 52.366 33.3706 49.2513C33.3706 46.1366 35.758 43.6909 38.8641 43.6909C42.2787 43.6909 44.3318 46.3165 44.2028 49.8427H35.1669C35.3979 51.8756 36.7839 53.2666 39.1196 53.2666L39.1209 53.2679ZM42.4064 48.4801C42.2529 46.6529 41.0966 45.2114 38.8641 45.2114C36.8368 45.2114 35.4754 46.5235 35.1927 48.4801H42.4064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1279 54.3483L51.3388 49.5863C53.059 48.0167 54.0591 46.8831 54.0591 45.4416C54.0591 43.8461 53.0074 43.0477 51.544 43.0477C49.9787 43.0477 48.8998 43.9742 48.3359 45.6732L46.6932 45.21C47.3087 42.8419 49.1579 41.4004 51.5195 41.4004C54.2398 41.4004 55.9084 42.9959 55.9084 45.364C55.9084 47.1406 54.6244 48.7103 52.7764 50.4093L50.8252 52.186C50.3632 52.6234 49.4909 53.0866 49.4909 53.0866C49.4909 53.0866 50.4407 53.009 50.9285 53.009H56.2426V54.5786H46.1292V54.347L46.1279 54.3483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0003 52.5215V54.0407H68.0749V57.0014H66.2786V54.0407H58.0132V53.1659L67.8181 41.3516H68.0749V52.5228H70.0003V52.5215ZM66.2786 46.679C66.2786 46.1381 66.356 45.3151 66.356 45.3151C66.356 45.3151 65.9457 45.9324 65.5856 46.3956L61.3245 51.6726C60.94 52.1359 60.4005 52.5991 60.4005 52.5991C60.4005 52.5991 61.0677 52.5215 61.6329 52.5215H66.2786V46.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1258 0H0V10.8425H35.3213C33.0437 7.35129 30.9041 3.77981 29.1258 0Z",
    fill: "url(#paint0_linear_4532_4552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1967 18.0673C38.5578 15.6681 36.9073 13.2742 35.32 10.8428H0V21.6853H42.6008C41.8111 20.4728 41.0149 19.2642 40.198 18.0673H40.1967Z",
    fill: "url(#paint1_linear_4532_4552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6008 21.6836H0V32.5261H49.479C47.182 28.9145 44.9353 25.2706 42.6008 21.6836Z",
    fill: "url(#paint2_linear_4532_4552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9253 0L61.6066 32.5263H65.5787C68.0202 32.5263 69.9998 30.5413 69.9998 28.093L49.4943 0H37.9253Z",
    fill: "#01BAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9999 4.43329C69.9999 1.98502 68.0204 0 65.5788 0H55.9106L70.0012 19.352V4.43329H69.9999Z",
    fill: "#01BAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4395 0L43.9246 32.5263H55.2472L31.5039 0H20.4395Z",
    fill: "#01BAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4532_4552",
    x1: 0,
    y1: 5.42062,
    x2: 22.4464,
    y2: 5.42062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4532_4552",
    x1: 4.63793,
    y1: 16.2634,
    x2: 35.7485,
    y2: 16.2634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4532_4552",
    x1: 13.204,
    y1: 27.1055,
    x2: 57.7264,
    y2: 27.1055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4532_4552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeLogo);
export default __webpack_public_path__ + "static/media/dark-mode-logo.4246dfaef06c7667977960f685d1474b.svg";
export { ForwardRef as ReactComponent };